import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { IssueHistoryListComponent } from '~/modules/stocks/history/issue-history/list.component';

@Injectable({ providedIn: 'root' })
export class IssueTransactionsService extends ApiServiceBase {
    FromInventory: any = [];
    SelectedSalesOrderId:number;
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    getIssueDetails(id: number) {
        return this.http.get<any[]>(this._url(`/stockissuedetails/${id}`));
    }

    createIssue(model: any) {
        return this.client.post<string>(this._url(), model);
    }

    getIssueHistories(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<any[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }



    GetIssueTransactionByStockItem(stockItemId : number, model : any){
        return this.http
        .post<any[]>(this._url(`/StockItems/${stockItemId}/grid-data`), model, {
          observe: 'response'})
        .pipe(map(augmentPaging));
      }


    GetIssueTransactionByUOM(unitOfMeasureId : number, model : any){
        return this.http
        .post<any[]>(this._url(`/UnitOfMeasures/${unitOfMeasureId}/grid-data`), model, {
          observe: 'response'})
        .pipe(map(augmentPaging));
      }


    GetIssueTransactionByCustomer(customerId : number, model : any){
      return this.http
      .post<any[]>(this._url(`/Customers/${customerId}/grid-data`), model, {
        observe: 'response'})
      .pipe(map(augmentPaging));
    }

    NumberOfStockItemsIssuedLastXMonths(top: number = 10){
      return this.client.get(this._url(`/NumberOfStockItemsIssuedLastXMonths/${top}`));
    }

    QuantityOfIssuedStockItemsLastXMonths(top: number = 10){
      return this.client.get(this._url(`/QuantityOfIssuedStockItemsLastXMonths/${top}`));
    }

    NumberOfIssuedTransactionLastXMonths(top: number = 10){
      return this.client.get(this._url(`/NumberOfIssuedTransactionLastXMonths/${top}`));
    }

    QuantityOfIssuedStockItemsPerCustomer(top: number = 10){
      return this.client.get(this._url(`/QuantityOfIssuedStockItemsPerCustomer/${top}`));
    }

    IssuedPerCustomer(top: number = 10){
      return this.client.get(this._url(`/IssuedPerCustomer/${top}`));
    }

    IssuedPerStockItem(top: number = 10){
      return this.client.get(this._url(`/IssuedPerStockItem/${top}`));
    }

    IssuedPerCategory(top: number = 10){
      return this.client.get(this._url(`/IssuedPerCategory/${top}`));
    }

    IssuedPerUser(top: number = 10){
      return this.client.get(this._url(`/IssuedPerUser/${top}`));
    }

    IssuedPerLocation(top: number = 10){
      return this.client.get(this._url(`/IssuedPerLocation/${top}`));
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/IssueTransactions${v}`);
    }
}
